@if (isLoading()) {
<!-- Details skeleton -->
<div class="d-flex flex-column gap-3">
  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title placeholder-glow">
        <span class="placeholder rounded col-4"></span>
      </h6>
    </div>
    <div class="card-body details-grid placeholder-glow">
      @for (i of [0,1,2,3]; track i) {
      <div class="detail-item">
        <div class="detail-label">
          <span class="placeholder rounded col-8"></span>
        </div>
        <div class="detail-value fw-bold">
          <span class="placeholder rounded col-8"></span>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title placeholder-glow">
        <span class="placeholder rounded col-3"></span>
      </h6>
    </div>
    <div class="card-body placeholder-glow">
      <span class="placeholder rounded col-12 mb-2 d-block"></span>
      <span class="placeholder rounded col-10 d-block"></span>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title placeholder-glow">
        <span class="placeholder rounded col-4"></span>
      </h6>
    </div>
    <div class="row g-3 m-2 mb-3 placeholder-glow">
      @for (i of [0,1,2]; track i) {
      <div class="col-12 col-md-4">
        <div class="doc-main d-flex align-items-center gap-2">
          <span
            class="placeholder rounded"
            style="width: 260px; height: 56px; display: inline-block"
          ></span>
        </div>
      </div>
      }
    </div>
  </div>
</div>
} @else {
<div class="d-flex flex-column gap-3">
  <!-- Details -->
  @if (project()) {
  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title">
        {{ "admin.projectIdeas.details.detailsTitle" | translate }}
      </h6>
    </div>
    <div class="card-body details-grid">
      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.state" | translate }}
        </div>
        <div class="detail-value fw-bold">
          {{ stateLabel(project()?.state) }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.projectType" | translate }}
        </div>
        <div class="detail-value fw-bold">
          {{ projectTypeLabel(project()?.foundingMode) }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{
            "admin.projectIdeas.details.investmentClassification" | translate
          }}
        </div>
        <div class="detail-value fw-bold">
          {{ project()?.classification?.code ?? "—" }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.loanTerm" | translate }}
        </div>
        <div class="detail-value fw-bold">
          {{ loanTermLabel(project()?.loanTerm) }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.plannedCollectionPeriod" | translate }}
        </div>
        <div class="detail-value fw-bold">{{ plannedPeriod() }}</div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.actualCollectionPeriod" | translate }}
        </div>
        <div class="detail-value fw-bold">{{ collectionPeriod() }}</div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.country" | translate }}
        </div>
        <div class="detail-value fw-bold">
          {{ getCountryName(project()?.country) }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.city" | translate }}
        </div>
        <div class="detail-value fw-bold">{{ project()?.city ?? "—" }}</div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.currency" | translate }}
        </div>
        <div class="detail-value fw-bold">{{ project()?.currency ?? "—" }}</div>
      </div>
    </div>
  </div>
  }

  <!-- Description -->
  @if (project()?.description) {
  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title">
        {{ "admin.projectIdeas.details.descriptionTitle" | translate }}
      </h6>
    </div>
    <div class="card-body">
      <p class="mb-0 description-text">{{ project()?.description }}</p>
    </div>
  </div>
  }

  <!-- Documents -->
  @if (files()) {
  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title">
        {{ "admin.projectIdeas.details.documentsTitle" | translate }}
      </h6>
    </div>
    <app-attachment-list [files]="files()" [loading]="isLoading()" />
  </div>
  }

  <!-- Contact -->
  @if (project() && hasContactUser()) {
  <div class="card">
    <div class="card-header">
      <h6 class="m-0 section-title">
        {{ "admin.projectIdeas.details.contactTitle" | translate }}
      </h6>
    </div>

    <div class="card-body contact-grid">
      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.name" | translate }}
        </div>
        <div class="detail-value fw-bold">
          {{ contactName() }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.phone" | translate }}
        </div>

        <div class="detail-value fw-bold">
          {{ contactUser()?.phoneNumber ?? "—" }}
        </div>
      </div>

      <div class="detail-item">
        <div class="detail-label">
          {{ "admin.projectIdeas.details.email" | translate }}
        </div>
        <div class="detail-value fw-bold">
          {{ contactUser()?.email ?? "—" }}
        </div>
      </div>
    </div>
  </div>
  }
</div>
}
